import { ReduxState } from '../../store';

export const selectDisableHotKeyEvents = (state: ReduxState) =>
  state.featureControlReducer.disableHotKeyEvents;
export const selectPlayerParams = (state: ReduxState) => state.featureControlReducer.playerParams;
export const selectIsFullScreen = (state: ReduxState) => state.featureControlReducer.isFullScreen;
export const selectPlayerFeatures = (state: ReduxState) =>
  state.featureControlReducer.playerFeatures;
